import React, { FC } from 'react';
import type { ISpAuthorizationToken } from 'ts/client/common';
import AlbumPageTitle from 'ts/common/components/gallery/AlbumPageTitle';
import type { ICoverPhotoBase } from 'ts/common/types';
import CoverSlideshowHeaderGate from './CoverSlideshowHeaderGate';

interface Props {
    albumCount?: number;
    albumId?: number | string | null;
    coverPhoto?: ICoverPhotoBase & { url: string };
    headingText: string;
    isLargeScreen?: boolean;
    /** Reports the header ready to render its final state — see `CoverSlideshowHeaderGate`. */
    onCoverSlideshowReady?: () => void;
    photoCount: number;
    spAuthorizationToken: ISpAuthorizationToken;
    spEventBus: SpAngularJs.ISpEventBus;
    translateFilter: SpAngularJs.ITranslateFilter;
}

/**
 * Wraps `AlbumPageTitle` in `CoverSlideshowHeaderGate` so a slideshow album cover plays inside
 * the album page's header the same way it already plays as the gallery's intro background.
 *
 * Kept out of `AlbumPageTitle` itself (and therefore out of `ts/common/components/gallery`, which
 * Studio's `GalleryPreview` also renders) so that client-only plumbing doesn't leak into a
 * component Studio's branding preview relies on rendering with no client-gallery services at all.
 */
const GalleryAlbumPageTitle: FC<Props> = ({
    albumId,
    coverPhoto,
    onCoverSlideshowReady,
    spAuthorizationToken,
    spEventBus,
    ...pageTitleProps
}) => (
    <CoverSlideshowHeaderGate
        albumId={albumId}
        coverPhoto={coverPhoto}
        onCoverSlideshowReady={onCoverSlideshowReady}
        spAuthorizationToken={spAuthorizationToken}
        spEventBus={spEventBus}
    >
        <AlbumPageTitle coverPhoto={coverPhoto} {...pageTitleProps} />
    </CoverSlideshowHeaderGate>
);

export default GalleryAlbumPageTitle;
